import React, { createContext, useState } from "react";

export const ClubFittingContext = createContext()


export const ClubFittingProvider = (props) => {

    const remotefittinginitialdata = {
        step0: {
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
            height_ft: "",
            height_in: "",
        },
        step1: {
            name: "white Irons",
            iron1: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron2: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron3: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            location: null,
            preferred_club: "",
        },
        step2: {
            name: "Black Irons",
            iron1: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron2: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron3: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            location: null,
            preferred_club: "",
        },
        step3: {
            name: "Blue Irons",
            iron1: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron2: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron3: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            location: null,
            preferred_club: "",
        },
        step4: {
            name: "Pink Irons",
            iron1: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron2: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron3: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            location: null,
            preferred_club: "",
        },
        step5: {
            name: "Purple Irons",
            iron1: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron2: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron3: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            location: null,
            preferred_club: "",
        },
        step6: {
            name: "Red Irons",
            iron1: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron2: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron3: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            location: null,
            preferred_club: "",
        },
        step7: {
            name: "Orange Irons",
            iron1: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron2: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron3: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            location: null,
            preferred_club: "",
        },
        step8: {
            name: "Green Irons",
            iron1: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron2: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            iron3: {
                shot1: {
                    option1: "",
                    option2: "",
                    option3: "",
                    optionx: "",
                    optiony: "",
                },
                shot2: {
                    option1: "",
                    option2: "",
                    option3: "",
                },
                shot3: {
                    option1: "",
                    option2: "",
                    option3: "",
                }
            },
            location: null,
            preferred_club: "",
        },
        step9: {
            notes: "",
        }
    }

    const remotefittinginitialimage = {
        step0: {
            swing1: '',
            swing2: '',
        },
        step1: {
            name: "white Irons",
            location: '',
        },
        step2: {
            name: "Black Irons",
            location: '',
        },
        step3: {
            name: "Blue Irons",
            location: '',
        },
        step4: {
            name: "Pink Irons",
            location: ''
        },
        step5: {
            name: "Purple Irons",
            location: '',
        },
        step6: {
            name: "Red Irons",
            location: '',
        },
        step7: {
            name: "Orange Irons",
            location: ''
        }, 
        step8: {
            name: "Green Irons",
            location: ''
        },
        
    }

    const [remotefittingdata, setRemotefittingdata] = useState(remotefittinginitialdata);
    const [remotefittingimage, setRemotefittingimage] = useState(remotefittinginitialimage);

    const updateremotefitting = (path, value) => {

        setRemotefittingdata((prevState) => {
            // Creating a deep copy of the state
            let newData = JSON.parse(JSON.stringify(prevState));
            // let newData = prevState;

            // Splitting the path and reducing it to find the nested object
            path.split('.').reduce((o, k, i, keys) => {
                if (i === keys.length - 1) {
                    o[k] = value; // Updating the value at the specific path
                }
                return o[k];
            }, newData);

            console.log("newData", newData);

            return newData;
        });
    }

    const updateremotefittingfile = (path, value) => {
        setRemotefittingimage((prevState) => {
            // Create a deep copy of the state
            const newState = { ...prevState };

            // Splitting the path and reducing it to find the nested object
            const keys = path.split('.');
            let nestedObject = newState;
            for (let i = 0; i < keys.length - 1; i++) {
                nestedObject = nestedObject[keys[i]];
            }

            // Update the value at the specific path
            nestedObject[keys[keys.length - 1]] = value;

            console.log("newData", newState);

            return newState;
        });
    }


    return (
        <ClubFittingContext.Provider value={{ remotefittingdata, setRemotefittingdata, updateremotefitting, remotefittingimage, setRemotefittingimage, updateremotefittingfile }}>
            {props.children}
        </ClubFittingContext.Provider>
    )
}

